import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../layouts/dashboard/default"));
const Index = lazy(() => import("../views/dashboard/index"));
const AlternateDashboard = lazy(() =>
  import("../views/dashboard/alternate-dashboard")
);
const Solid = lazy(() => import("../views/dashboard/icons/solid"));
const Outline = lazy(() => import("../views/dashboard/icons/outline"));
const DualTone = lazy(() => import("../views/dashboard/icons/dual-tone"));
const Userprofile = lazy(() => import("../views/dashboard/app/user-profile"));
const UserAdd = lazy(() => import("../views/dashboard/app/user-add"));
const UserList = lazy(() => import("../views/dashboard/app/user-list"));
const UserProfileEdit = lazy(() =>
  import("../views/dashboard/app/user-privacy-setting")
);
const Admin = lazy(() => import("../views/dashboard/admin/admin"));
const Widgetbasic = lazy(() => import("../views/dashboard/widget/widgetbasic"));
const Widgetchart = lazy(() => import("../views/dashboard/widget/widgetchart"));
const Widgetcard = lazy(() => import("../views/dashboard/widget/widgetcard"));
const Google = lazy(() => import("../views/dashboard/maps/google"));
const FormElement = lazy(() => import("../views/dashboard/from/form-element"));
const FormWizard = lazy(() => import("../views/dashboard/from/form-wizard"));
const FormValidation = lazy(() =>
  import("../views/dashboard/from/form-validation")
);
const Fancytable = lazy(() => import("../views/dashboard/table/fancy-table"));
const FixedTable = lazy(() => import("../views/dashboard/table/fixed-table"));

export const DefaultRouter = [
  {
    path: "/",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Index />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/alternate-dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AlternateDashboard />
          </Suspense>
        ),
      },

      {
        path: "dashboard/app/user-profile",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Userprofile />
          </Suspense>
        ),
      },
      {
        path: "dashboard/app/user-roles",
        element: (
          <Suspense fallback={<Backdrop />}>
            <UserProfileEdit />
          </Suspense>
        ),
      },
      {
        path: "dashboard/app/user-add",
        element: (
          <Suspense fallback={<Backdrop />}>
            <UserAdd />
          </Suspense>
        ),
      },
      {
        path: "dashboard/app/user-list",
        element: (
          <Suspense fallback={<Backdrop />}>
            <UserList />
          </Suspense>
        ),
      },
      {
        path: "dashboard/admin/admin",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Admin />
          </Suspense>
        ),
      },
      {
        path: "dashboard/widget/widgetbasic",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Widgetbasic />
          </Suspense>
        ),
      },
      {
        path: "dashboard/widget/widgetchart",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Widgetchart />
          </Suspense>
        ),
      },
      {
        path: "dashboard/widget/widgetcard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Widgetcard />
          </Suspense>
        ),
      },
      {
        path: "dashboard/map/google",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Google />
          </Suspense>
        ),
      },
      {
        path: "dashboard/form/form-element",
        element: (
          <Suspense fallback={<Backdrop />}>
            <FormElement />
          </Suspense>
        ),
      },
      {
        path: "dashboard/form/form-wizard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <FormWizard />
          </Suspense>
        ),
      },
      {
        path: "dashboard/form/form-validation",
        element: (
          <Suspense fallback={<Backdrop />}>
            <FormValidation />
          </Suspense>
        ),
      },
      {
        path: "dashboard/table/fancy-table",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Fancytable />
          </Suspense>
        ),
      },
      {
        path: "dashboard/table/fixed-table",
        element: (
          <Suspense fallback={<Backdrop />}>
            <FixedTable />
          </Suspense>
        ),
      },
      {
        path: "dashboard/icon/solid",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Solid />
          </Suspense>
        ),
      },
      {
        path: "dashboard/icon/outline",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Outline />
          </Suspense>
        ),
      },
      {
        path: "dashboard/icon/dual-tone",
        element: (
          <Suspense fallback={<Backdrop />}>
            <DualTone />
          </Suspense>
        ),
      },
    ],
  },
];
